import { createApp } from "vue";

import Search from "./Search.vue";
import SearchResultList from "./SearchResultList.vue";
import RoomCard from "@components/RoomCard.vue";
import SearchFilters from "./SearchFilters.vue";
import Price from "@components/Price.vue";

const handle = "almero-vue-search";
const mountEls = document.querySelectorAll(`.${handle}`);

mountEls.forEach((mountEl) => {
    let props = {};
    try {
        props = JSON.parse(mountEl.dataset.rootProps);
    }
    catch (e) {
        console.error(e);
    }
    const app = createApp(
        Search, {
            ...props,
        }
    );

    app.component("Search", Search);
    app.component("SearchResultList", SearchResultList);
    app.component("RoomCard", RoomCard);
    app.component("SearchFilters", SearchFilters);
    app.component("Price", Price);

    app.mount(mountEl);
});